
import { Component, Vue, Watch } from "vue-property-decorator";
import { Loading, CardLavorazione, WorkflowLavorazione, ProgressoLavorazione, ProgressoSpedizione, LavorazioniCards, LoadingTemplateType } from "@/components";
import { Ordine, LavorazioneSlim } from "@/models";
import { store, StoreActions, StoreMutations } from "@/store";
import saveAs from "file-saver";
import { OrdineSpacchettatoDettaglio } from "@/models/OrdineSpacchettatoDettaglio";
import { OrdineSpacchettatoTestata } from "@/models/OrdineSpacchettatoTestata";

@Component({
    components: {
        Loading,
        CardLavorazione,
        WorkflowLavorazione,
        ProgressoLavorazione,
        ProgressoSpedizione,
        LavorazioniCards
    }
})
export default class OrdineSpacchettato extends Vue {
    public mostraHeader = true;
    public dialog = false;
    public compact = false;
    private idLam : string = "";

    get ordine(): OrdineSpacchettatoTestata | undefined {
        return store.state.ordineSpacchettatoTestata;
    }

    get ordDettaglio(): (OrdineSpacchettatoDettaglio[] | undefined){
        if(store.state.ordineSpacchettatoDettaglio){
            var ord = store.state.ordineSpacchettatoDettaglio.sort((a,b) => a.id <= b.id ? 1 : -1);
            ord = store.state.ordineSpacchettatoDettaglio.sort((a,b) => a.idLakpet >= b.idLakpet ? 1 : -1);
            return ord
        }
        return undefined;
    }

    get infoRighe() : any[]{
        var lavorazioni = this.ordDettaglio;

        if(!lavorazioni || !lavorazioni.length)
            return [];
        var classi = [],
            currClasse = "rigaAlt",
            lastLAK = "";
        for(var i = 0; i < lavorazioni.length; i++){
            var lav = lavorazioni[i],
                marginTop = 2;
            if(lav && lav.idLakpet !== lastLAK){
                currClasse = currClasse === "rigaAlt" ? "" : "rigaAlt";
                lastLAK = lav.idLakpet;
                marginTop = 10;
            }
            classi.push({
                classe:currClasse,
                marginTop: marginTop
            });
        }
        return classi;
    }

    get loadTemplateCorrente(): LoadingTemplateType {
        return LoadingTemplateType.OrdineDettaglio;
    }

    cloneObject(obj: any) : any{
        return JSON.parse(JSON.stringify(obj));
    }

    public headers = [
        { text: "Indice", sortable: false },
        { text: "Codice", sortable: false },
        { text: "Descrizione", sortable: false },
        { text: "Colore", sortable: false },
        { text: "Um", sortable: false },
        { text: "Quantità", sortable: false },
        { text: "Partita", sortable: false },
        { text: "Utilizzo", sortable: false },
        { text: "Contenitore", sortable: false }
    ];

    @Watch("$route.params.id", { immediate: true })
    async onIdChanged(newId: string, oldId: string) {
        if (oldId) {
            this.beforeDestroy();
        }
        this.idLam = newId;
        store.commit(StoreMutations.SetSottotitoloPagina, newId);
        await store.dispatch(StoreActions.GetOrdine, newId);
        await store.dispatch(StoreActions.GetOrdineSpacchettatoTestata, newId);
        var ord = store.state.ordineSpacchettatoTestata;
        if (ord && this.ordine) {
            await store.dispatch(StoreActions.GetOrdineSpacchettatoLista, {stagione: ord?.stagione, linea: ord?.ordineLinea, 
                numeroOrdine: ord?.ordineNumero, page: 1, pageSize: 100} );
            
            var ordineLista = store.state.ordineSpacchettatoLista;

            if(ordineLista && ordineLista.length){

                var idLids = ordineLista.map(x => x.id);

                await store.dispatch(StoreActions.GetOrdineSpacchettatoDettaglio, {idLids: idLids, page: 1, pageSize: 100} );
                store.dispatch(StoreActions.WatchNotificheGruppi);
            }
           
        }
    }

    get loading() {
        return store.state.loading && !this.dialog;
    }

    get xlsxPackingListLavorazioneSpacchettatoLoading() : any {
        return store.state.uiLavorazione.xlsxPackingListLavorazioneSpacchettatoLoading;
    }

    getHeadersTaglie(lavorazione: OrdineSpacchettatoDettaglio): any[] {
        let titoli = [
            {
                text: "Taglie",
                value: "Taglie",
                align: 'center',
                indice: "",
                sortable: false,
                barcode: ""
            }
        ];

        if(lavorazione != undefined) {
            let tipoTaglia: any = lavorazione.tipoTagliaDecodificato;
            //let innerLavorazione : any = lavorazione.innerLavorazione;
            let innerLavorazione : any = lavorazione;

            for (let index = 1; index <= 16; index++) {
                const nomeProp = `taglia${index.toString().padStart(2, '0')}`;
                const valProp: string = tipoTaglia[nomeProp];

                const barcodeNomeProp : string = `barcode${index.toString().padStart(2, '0')}`
                const barcodeValProp: string = innerLavorazione[barcodeNomeProp] || null;

                let end = valProp == undefined || valProp == '';
                if(!end) {
                    titoli.push({
                        text: valProp,
                        value: valProp,
                        align: 'center',
                        sortable: false,
                        indice: index.toString(),
                        barcode: barcodeValProp
                    })
                }
            }
        }

        return titoli;
    }

    getItemsTaglie(lavorazione: OrdineSpacchettatoDettaglio): any[] {
        let rows: any[] = [];
        if(lavorazione != undefined) {
            //let capiTaglia: any = lavorazione.innerLavorazione;
            let capiTaglia: any = lavorazione;

            // Riga numero totali capi per lavorazione (tipoRiga: 0)
            let rigaTotali = { id: -2, tipoRiga: 0, values: [] as string[] };
            rigaTotali.values.push("")
            var headers = this.getHeadersTaglie(lavorazione);
            for (let index = 1; index <= headers.length-1; index++) {
                const nomeProp = `capi${index.toString().padStart(2, '0')}`;
                const valProp: string = "" + (parseInt(capiTaglia[nomeProp]) || "-");

                rigaTotali.values.push(valProp);
            }
            rows.push(rigaTotali);
        }

        return rows;
    }


    private beforeDestroy() {
        //store.dispatch(StoreActions.UnwatchLavorazioni, this.idLavorazioni);
        store.dispatch(StoreActions.UnwatchNotificheGruppi);
    }

    public caricamentoDistinta: boolean = false;

    
    public async downloadXLSXPackingListLavorazioneSpacchettato(lavorazione: OrdineSpacchettatoDettaglio) {
        let data = await store.dispatch(StoreActions.DownloadXLSXPackingListLavorazioneSpacchettato, {idLavorazione: lavorazione?.id, idOrdine: this.idLam});
        if (data) {
            saveAs(data, `packing_list_lavorazione_${lavorazione?.id}.xlsx`);
        }
    }
    

    private iconClassByProgress(lav: LavorazioneSlim): string {
        if (lav.progresso == 0) {
            return "grey";
        } else if (lav.progresso == 100) {
            return "green";
        }

        return "amber";
    }

    public getChipColorByHashedString(nome: string): string {
      const colorArray = ["grey", "red", "pink", "purple", "deep-purple", "indigo", "blue",
      "light-blue", "cyan", "teal", "green", "light-green", "lime", "yellow", "amber",
      "orange", "deep-orange", "brown", "blue-grey"];
      var hash = 0, i, chr;
      for (i = 0; i < nome.length; i++) {
        chr   = nome.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
      }
      if(hash < 0) hash = -hash;
      return colorArray[hash % colorArray.length];
  }
}
